import React from "react"
import { Collapsible } from "@base-ui/react/collapsible"
import { cn } from "../utils"

// =============================================================================
// Props
// =============================================================================

export type StepperItemContentProps = {
  /** Content revealed when the step is expanded */
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const contentStyles = [
  // content sticks to the bottom of the panel box so it slides out from the trigger
  "flex flex-col justify-end",
  // handle hidden="until-found" correctly
  "[&[hidden]:not([hidden='until-found'])]:hidden",
  // --collapsible-panel-height is measured and exposed by BaseUI
  "h-[var(--collapsible-panel-height)] overflow-hidden",
  "transition-[height] ease-out data-[ending-style]:h-0 data-[starting-style]:h-0 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 duration-150"
]

// =============================================================================
// Component
// =============================================================================

/**
 * The collapsible panel revealed when an expandable step is open.
 *
 * Must be a descendant of an expandable `Stepper.Item`.
 */
export function StepperItemContent({ children }: StepperItemContentProps) {
  return (
    <Collapsible.Panel
      hiddenUntilFound
      data-slot="stepper-item-content"
      className={cn(contentStyles)}
    >
      <span className="pt-2 text-sm text-gray-800">{children}</span>
    </Collapsible.Panel>
  )
}

StepperItemContent.displayName = "Stepper.ItemContent"
